import { BehaviorSubject } from 'rxjs';
import { CoordinatesModel } from './coordinates.model';
import { DimensionsModel } from './dimensions.model';

export class WatchedElementModel {
    element: HTMLElement;
    previousCoordinates: CoordinatesModel;
    change: BehaviorSubject<CoordinatesModel>;
    resize: BehaviorSubject<CoordinatesModel>;

    constructor(
        element: HTMLElement
    ) {
        this.constructFromElement(element);
    }

    /**
     * Unsubscribes from all changes
    */
    public unsubscribe(): void {
        this.change.unsubscribe();
        this.resize.unsubscribe();
    }

    private constructFromElement(
        element: HTMLElement,
        previousCoordinates: CoordinatesModel = null
    ): void {
        this.element = element;
        this.previousCoordinates = previousCoordinates;

        this.change = new BehaviorSubject<CoordinatesModel>(null);
        this.resize = new BehaviorSubject<DimensionsModel>(null);
    }
}
